export const styles = {
  card: {
    background: "#ffffff",
    borderRadius: "20px",
    boxShadow: "0px 25px 25px rgba(0, 0, 0, 0.25)",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
  },
  headerGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    width: "100%",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "28px",
    width: "100%",
  },
  title: {
    margin: 0,
    fontFamily: "Inter, sans-serif",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "-0.4492px",
    color: "#000000",
  },
  closeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    width: "28px",
    height: "28px",
    boxSizing: "border-box",
    padding: "4px",
  },
  description: {
    margin: 0,
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    color: "#7D8690",
    width: "100%",
  },
  videoWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  videoThumbnail: {
    position: "relative",
    width: "100%",
    height: "199px",
    borderRadius: "12px",
    overflow: "hidden",
    cursor: "pointer",
    display: "block",
  },
  videoThumbnailImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center 47%",
    display: "block",
  },
  videoIframe: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },
  playHitArea: {
    position: "absolute",
    top: "26%",
    left: "22%",
    width: "26%",
    height: "50%",
    cursor: "pointer",
  },
  openHitArea: {
    position: "absolute",
    top: "26%",
    left: "51%",
    width: "26%",
    height: "50%",
    cursor: "pointer",
  },
  maybeLater: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "20px",
    color: "#2A85FF",
    cursor: "pointer",
    textAlign: "center",
  },
};
